import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { extendCommonStylesheet } from "@devowl-wp/web-cookie-banner";
import { useStylesheet } from "../../contexts/stylesheet.js";
import { useA11yId } from "../../hooks/useA11yId.js";
const GroupButton = ({ legend, active, onChange, items })=>{
    const { ButtonGroup, buttonGroupItem, screenReaderOnlyClass, Label } = useStylesheet().extend(...extendCommonStylesheet);
    const a11yName = useA11yId();
    const handleChange = (e)=>{
        const { value } = e.target;
        onChange(value);
    };
    return /*#__PURE__*/ _jsxs(ButtonGroup, {
        children: [
            /*#__PURE__*/ _jsx("legend", {
                className: screenReaderOnlyClass,
                children: legend
            }),
            items.map(({ key, value })=>/*#__PURE__*/ _jsxs(Label, {
                    children: [
                        /*#__PURE__*/ _jsx("input", {
                            name: a11yName,
                            type: "radio",
                            value: key,
                            checked: active === key,
                            className: buttonGroupItem,
                            "aria-label": value,
                            onChange: handleChange
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            "aria-hidden": true,
                            children: value
                        })
                    ]
                }, key))
        ]
    });
};
export { GroupButton };
